import * as React from 'react'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import Chip from '@mui/material/Chip'
// import ClockIcon from '@mui/icons-material/WatchLater';
import { FieldProps, useRecordContext } from 'react-admin'
import ClockIcon from '@mui/icons-material/Schedule'

export const StatusField: React.FC<FieldProps> = ({ source }) => {
  const record = useRecordContext()
  if (!record) return null

  const value: string = record[source]
  let icon: React.ReactElement = null,
    variant: 'outlined' | null = null

  const displayValue = [value.charAt(0).toUpperCase(), ...value.slice(1)].join('')

  switch (value) {
    case 'active': {
      icon = <CheckOutlinedIcon />
      break
    }
    case 'invited': {
      icon = <ClockIcon />
      variant = 'outlined'
      break
    }
  }

  return <Chip variant={variant ?? undefined} icon={icon} size="small" label={displayValue} />
}
